import { app } from './app.js';

export function log(msg) {
	if (app.env === 'DEVELOPMENT') {
		console.log(msg);
	}
}

export default {};
